import Stack from '@mui/material/Stack';
import React, { useState } from 'react';
import { MyMButton } from '../ui-elements/MyMButton';
import { MyMTreeCheckbox } from '../ui-elements/MyMTreeCheckbox';
import Box from '@mui/material/Box';

export const ApliableTreeCheckbox = (props) => {
  const {
    treeItemList,
    checkedList,
    setChecked,
    clearText,
    handleClearAll,
    isShrink,
    needsCascade,
    isAsset
  } = props;

  const [expandList, setExpandList] = useState(treeItemList.map(x => x.Id));
  const [isShrinkState, setIsShrinkState] = useState(isShrink);

  // isShrink(折りたたむフラグ)=true かつ 
  if (isShrink && isShrinkState) {
    if (isAsset) {
      var assetList = treeItemList.filter(x => x.Name === 'Asset');
      setExpandList(assetList.map(x => x.Id));
    } else {
      setExpandList([]);
    }
    setIsShrinkState(false);
  }

  /** ClearAllクリックイベント */
  const onClearAllClick = () => {
    // チェックリストをクリア
    setChecked([]);

    // 折りたたみフラグが設定されている場合、expandListをクリア
    if (isShrink) {
      setExpandList([]);
    }

    // イベントが設定されていた場合実行
    if (handleClearAll != null) {
      checkedList.length = 0;
      handleClearAll();
    }
  }

  return (
    <>
      <Stack spacing={2} sx={{ padding: '1px', marginBottom: 1, }} direction='row' justifyContent='flex-end' >
        <MyMButton onClick={onClearAllClick}>{clearText}</MyMButton>
      </Stack>
      <Box sx={{ overflow: 'auto', height: '90%', width: '100%' }}>
        <MyMTreeCheckbox
          treeItemList={treeItemList}
          checkedList={checkedList}
          setCheckedList={setChecked}
          expanded={expandList}
          setExpanded={setExpandList}
          needsCascade={needsCascade}
        />
      </Box>
    </>
  );
}
